var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7332 32.0815H5.49006C2.45874 32.0815 0 29.6227 0 26.5914V5.49006C0 2.45874 2.45874 0 5.49006 0H17.7332C20.7646 0 23.2233 2.45874 23.2233 5.49006V26.5914C23.2233 29.6227 20.7646 32.0815 17.7332 32.0815ZM5.49006 2.02088C3.57022 2.02088 2.02088 3.57022 2.02088 5.49006V26.5914C2.02088 28.5113 3.57022 30.0606 5.49006 30.0606H17.7332C19.6531 30.0606 21.2024 28.5113 21.2024 26.5914V5.49006C21.2024 3.57022 19.6531 2.02088 17.7332 2.02088H5.49006Z",
    fill: "#6C6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6034 3.51953C10.8455 3.51953 10.2393 4.1258 10.2393 4.88363C10.2393 5.64146 10.8455 6.24772 11.6034 6.24772C12.3612 6.24772 12.9674 5.64146 12.9674 4.88363C12.9674 4.1258 12.3612 3.51953 11.6034 3.51953Z",
    fill: "#6C6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2233,
    height: 32.0815,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.36bf95db25339bd0ea9e00604f882d01.svg";
export { ForwardRef as ReactComponent };